import { isFunction } from "./utils";

/**
 * For collecting Error-Elements to highlight.
 */
export class ErrorElemContainer {

  public elems: any[] = [];

  add(elem: any) {
    if (elem) {
      this.elems.push(elem);
    }
  }

  highlightErrors() {
    for (let elem of this.elems) {
      if (isFunction(elem.highlightError)) {
        elem.highlightError();
      }
    }
  }
}
